import React, { createContext,  useCallback,useContext,  useMemo, useRef, useState,useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchMainPageData,  usePersistedState } from '../utils/Common';
import { UserProfileContext } from './UserProfileProvider';
export const NavbarContext = createContext();

export const NavProvider = ({ children }) => {
  const { tokenLoaded } = useContext(UserProfileContext);
  const [basicOpen, setBasicOpen] = useState(false);
  const [business, setBusiness] = usePersistedState('B2B');
  const [avatar, setAvatar] = usePersistedState('avatar', localStorage.getItem('AVATAR'),tokenLoaded);

  const localStorageCondition = Boolean(localStorage.getItem('isPricing'));
  const xTrkCondition = Boolean(window.location.host.includes("x-trk"));
  const expensesCondition = Boolean(window.location.host.includes("expenses"));
  const shouldRenderPricingInfo = (  localStorageCondition || xTrkCondition || expensesCondition);
  const [isPricing,setIsPricing] = usePersistedState('isPricing',false,shouldRenderPricingInfo);
  const [isDark, setIsDark] = useState(false)
  const containerRef = useRef(null);
  const [permissions, setPermissions] = usePersistedState('permissions', [undefined],tokenLoaded);
  const [pageData, setPageData] = usePersistedState('pageData', undefined);


  

  const clearNavState = useCallback(() => {
  
    setBasicOpen(false);   
    setAvatar("");    
    setIsPricing(false);
    setIsDark(false);   
    localStorage.removeItem("DOMAIN");
    localStorage.removeItem("JWT-TOKEN"); 
    localStorage.removeItem("CART-ID"); 
    localStorage.removeItem("DPM"); 
    localStorage.removeItem("SUBSCRIPTION");    
}, [setAvatar, setIsPricing]);

useEffect(() => {
  if (!tokenLoaded) {
    clearNavState();
  }
}, [tokenLoaded, clearNavState]);


useEffect(() => {    
  fetchMainPageData(pageData,setPageData, setIsPricing,setBusiness);
}, [setIsPricing, setBusiness, pageData, setPageData]); 

  const value = useMemo(() => ({
  
    avatar, setAvatar, permissions, setPermissions, basicOpen, setBasicOpen, business, setBusiness, isPricing, setIsPricing, isDark, setIsDark, containerRef,setPageData,pageData,xTrkCondition
  }), [avatar, basicOpen, business, isDark, isPricing, pageData, permissions, setAvatar, setBusiness, setIsPricing, setPageData, setPermissions,containerRef,xTrkCondition]);

  return (
    <NavbarContext.Provider value={value}>
      {children}
    </NavbarContext.Provider>
  );
};

NavProvider.propTypes = {
    children: PropTypes.node,
     };